import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import "./Containers.css"
import { Pagination, Stack } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { Search, Plus, ThreeDotsVertical, Download, Funnel } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button } from 'react-bootstrap';
import { notificationActions } from '../../data/notification';
import CreateContainer from './CreateContainer';
import SetContainerAsOpen from './SetContainerAsOpen';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from '../../i18n/useT';

const Containers = () => {
    const t = useT();
    const [filter, setFilter] = useState({keyword: "", start_date: "", end_date: "", limit: 10, page: 1, asc: "desc", sort_by: "id", status: ""});
    const [container, setContainer] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const lang = useSelector((state) => state.user.language);
    const [keyword, setKeyword] = useState("");
    const [showDateSelector, setShowDateSelector] = useState(false);
    const [dates, setDates] = useState({start_date: "", end_date: ""});
    const [showFilters, setShowFilters] = useState(false);
    const [containerForm, setContainerForm] = useState({});
    const [showContainer, setShowContainer] = useState(false);
    const [actionType, setActionType] = useState("add");
    const [formLoader, setFormLoader] = useState(false);
    const dispatch = useDispatch();
    const [actionsId, setActionsId] = useState("");
    const [setContainerOpenModal , setSetContainerOpenModal] = useState(false);
    const {view, setView, isMobile} = useViewMode("containers-view");

    const rowActions = (c) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(c.id)} style={{cursor: "pointer"}}/>
            {actionsId === c.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setContainerForm({...c});
                        setShowContainer(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setContainerForm({...c});
                        setShowContainer(true);
                    }}>{t("common.delete")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setContainerForm((prev) => ({...prev, id: c.container_number}));
                        setSetContainerOpenModal(true);
                    }}>{t("containers.setAsOpen")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("containers.purchaseDate"), value: (c) => c.purchase_date !== null ? core.formdatDate(c.purchase_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("containers.vehicleName"), value: (c) => `${c.manufacturer} ${c.model} ${c.manufacturer_year}`},
        {label: t("containers.buyer"), value: (c) => c.buyer_name},
        {label: t("containers.booking"), value: (c) => c.booking},
        {label: t("containers.deliveryLocation"), value: (c) => c.delivery_location},
        {label: t("containers.containerOpenDate"), value: (c) => c.container_open_date !== null ? core.formdatDate(c.container_open_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("containers.lines"), value: (c) => c.line},
        {label: t("containers.personalNumber"), value: (c) => c.personal_number},
        {label: t("containers.lotStock"), value: (c) => c.lot_number},
        {label: t("containers.loadingPort"), value: (c) => c.loading_port},
        {label: t("containers.containerLoadedDate"), value: (c) => c.container_loaded_date !== null ? core.formdatDate(c.container_loaded_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("containers.containerReceiveDate"), value: (c) => c.container_receive_date !== null ? core.formdatDate(c.container_receive_date, "yyyy-mm-dd") : t("table.noData")},
    ];

    const handlers = {
        createContainer(e){
            e.preventDefault();
            setFormLoader(true);
            axios.post('/api/containers', containerForm)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShowContainer(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyContainer(){
            
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/containers?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&asc=${filter.asc}&start_date=${filter.start_date}&end_date=${filter.end_date}&sort_by=${filter.sort_by}&status=${filter.status}`)
            .then((res) => {
                setLoading(false);
                setContainer(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("containers.title")}</h2>
            <div className="table-filter-container">
                <div className='data-table-filteres'>
                    <Button onClick={() => setShowFilters(true)} variant='primary' style={{marginRight: "15px", color: "white", display: "flex", alignItems: "center"}}><Funnel style={{fontSize: "20px", fontWeight: "bold", marginRight: "6px"}} /> <span>{t("common.filters")}</span></Button>
                    {showFilters && <OutsideClickHandler onOutsideClick={() => setShowFilters(false)}>
                        <div className='data-table-filters-dropdown'>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.sort_by} onChange={(e) => setFilter((prev) => ({...prev, sort_by: e.target.value}))}>
                                    <option value={"id"}>{t("common.sortBy")}</option>
                                    <option value={"container_loaded_date"}>{t("containers.containerLoadedDate")}</option>
                                    <option value={"container_receive_date"}>{t("containers.containerReceiveDate")}</option>
                                    <option value={"est_opening_date"}>{t("containers.estimatedOpeningDate")}</option>
                                    <option value={"open_date"}>{t("containers.openDate")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.asc} onChange={(e) => setFilter((prev) => ({...prev, asc: e.target.value}))}>
                                    <option value={""}>{t("containers.oldToNew")}</option>
                                    <option value={"desc"}>{t("containers.newToOld")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, line: e.target.value}))}>
                                    <option value={""}>{t("containers.filterPort")}</option>
                                    <option value={"Port of WA Washington"}>Port of WA Washington</option>
                                    <option value={"Port of CA California"}>Port of CA California</option>
                                    <option value={"Port of TX Texas"}>Port of TX Texas</option>
                                    <option value={"Port of GA Georgia"}>Port of GA Georgia</option>
                                    <option value={"Port of NJ New Jersey"}>Port of NJ New Jersey</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, line: e.target.value}))}>
                                    <option value={""}>{t("containers.selectLine")}</option>
                                    <option value={"Evergreen"}>Evergreen</option>
                                    <option value={"Maersk"}>Maersk</option>
                                    <option value={"MSC"}>MSC</option>
                                    <option value={"Hapag-Lloyd"}>Hapag-Lloyd</option>
                                    <option value={"CMA CGM"}>CMA CGM</option>
                                    <option value={"ONE"}>ONE</option>
                                    <option value={"COSCO"}>COSCO</option>
                                    <option value={"ZIM"}>ZIM</option>
                                    <option value={"TURKON"}>TURKON</option>
                                </select>
                            </div>
                            <div className='date-selector-dropdown-container'>
                                <div className='date-selector-button' onClick={() => setShowDateSelector(!showDateSelector)}>{t("common.selectDate")}</div>
                                {showDateSelector && <OutsideClickHandler onOutsideClick={() => setShowDateSelector(false)}>
                                    <div className='date-selector-dropdown'>
                                        <div className='date-selector' style={{marginTop: "0px"}}>
                                            <span>{t("common.startDate")}</span>
                                            <input value={dates.start_date} type='date' onChange={(e) => setDates((prev) => ({...prev, start_date: e.target.value}))} className='form-control'/>
                                        </div>
                                        <div className='date-selector'>
                                            <span>{t("common.endDate")}</span>
                                            <input value={dates.end_date} type='date' className='form-control' onChange={(e) => setDates((prev) => ({...prev, end_date: e.target.value}))}/>
                                        </div>
                                        <Button onClick={() => setFilter((prev) => ({...prev, start_date: dates.start_date, end_date: dates.end_date}))} style={{width: "200px", marginTop: "15px"}}>{t("common.confirmDate")}</Button>
                                        <Button variant='danger' onClick={() => {
                                            setFilter((prev) => ({...prev, start_date: "", end_date: ""}));
                                            setDates({start_date: "", end_date: ''});
                                        }} style={{width: "200px", marginTop: "15px"}}>{t("common.clearDate")}</Button>
                                    </div>
                                </OutsideClickHandler>}
                            </div>
                        </div>    
                    </OutsideClickHandler>}
                </div>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <button className='btn btn-primary mr-3' style={{marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center"}} onClick={() => {
                    const qs = `keyword=${encodeURIComponent(filter.keyword)}&start_date=${filter.start_date}&end_date=${filter.end_date}&status=${filter.status}`;
                    window.open(`/api/containers/export?${qs}`, "_blank");
                }}><Download style={{fontSize: "20px", fontWeight: "bold", marginRight: "6px"}}/> <span>{t("common.export")}</span></button>
                <Button variant='primary' onClick={() => {
                    setShowContainer(true);
                    setActionType("add");
                    setContainerForm({});
                }} style={{display: "flex", alignItems: "center", marginRight: "15px"}}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></Button>
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>VIN</th>
                        <th>{t("containers.containerHash")}</th>
                        <th>{t("containers.purchaseDate")}</th>
                        <th>{t("containers.vehicleName")}</th>
                        <th>{t("containers.buyer")}</th>
                        <th>{t("containers.booking")}</th>
                        <th>{t("containers.deliveryLocation")}</th>
                        <th>{t("containers.containerOpenDate")}</th>
                        <th>{t("containers.lines")}</th>
                        <th>{t("containers.personalNumber")}</th>
                        <th>{t("containers.lotStock")}</th>
                        <th>{t("containers.loadingPort")}</th>
                        <th>{t("containers.containerLoadedDate")}</th>
                        <th>{t("containers.containerReceiveDate")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={14}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (container.length > 0 && !loading) && container.map((container) => {
                            return(
                                <tr key={container.id}>
                                    <td>{container.vin}</td>
                                    <td>{container.container_number}</td>
                                    <td>{container.purchase_date !== null ? core.formdatDate(container.purchase_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{container.manufacturer} {container.model} {container.manufacturer_year}</td>
                                    <td>{container.buyer_name}</td>
                                    <td>{container.booking}</td>
                                    <td>{container.delivery_location}</td>
                                    <td>{container.container_open_date !== null ? core.formdatDate(container.container_open_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{container.line}</td>
                                    <td>{container.personal_number}</td>
                                    <td>{container.lot_number}</td>
                                    <td>{container.loading_port}</td>
                                    <td>{container.container_loaded_date !== null ? core.formdatDate(container.container_loaded_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{container.container_receive_date !== null ? core.formdatDate(container.container_receive_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{rowActions(container)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && container.length === 0) && <tr><td colSpan={14} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : container}
                    loading={loading}
                    getKey={(c) => c.id}
                    renderTitle={(c) => c.vin}
                    renderSubtitle={(c) => c.container_number}
                    fields={cardFields}
                    renderActions={(c) => rowActions(c)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <CreateContainer show={showContainer} setShow={setShowContainer} formData={containerForm} setFormData={setContainerForm} submit={handlers.createContainer} loading={formLoader} type={actionType}/>
            <SetContainerAsOpen show={setContainerOpenModal} setHide={setSetContainerOpenModal} container_number={containerForm.id} />
        </div>
    )
}

export default Containers